import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  confirmDelete,
  ErrorMsg,
  GetFormData,
  InfoIcon,
  sessionUser,
  ValidateForm,
} from "../../../Util/common";

import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { KendoTreeTable } from "../../../Kendo/kendo_treetable";
import { KendoMultiSelect } from "../../../Kendo/kendo_multiselect";
import { KendoLoader } from "../../../Kendo/kendo_loader";
import {
  CorebaseURL,
  corefetch,
  corepost,
  ImageURL,
} from "../../../Util/axios_core_helper";

export const RentalHighlights = () => {
  const [MainDescription, setMainDescription] = useState({
    rentalHighlightsID: 0,
    MainDescription: "",
  });
  const [RentalHighlights, setRentalHighlights] = useState({
    rentalHighlightsID: 0,
    Title: "",
    Description: "",
    SortOrder: 0,
  });

  const [refreshflag, setrefreshflag] = useState(0);
  const [editVisible, setEditVisible] = useState(false);
  const [RentalHighlightseditVisible, setRentalHighlightseditVisible] =
    useState(false);

  const [GuidelineeditVisible, setGuidelineeditVisible] = useState(false);
  const [error, setError] = useState({});
  const modalRef = useRef(null);
  const GuidelinemodalRef = useRef(null);
  const { selDisplayedInIds } = useSelector((state) => state.VendorServices);
  const [MainDescriptionData, setMainDescriptionData] = useState([]);

  const dispatch = useDispatch();
  const [Loading, setLoading] = useState(false);
  const [VendorGridList, setVendorGridList] = useState([]);
  const [VTDup, setVTDup] = useState(false);
  const [refreshGrid, setrefreshGrid] = useState(0);
  const [HideAdd, setHideAdd] = useState(false);

  const Parentscolumns = [
    {
      field: "rentalHighlightsID",
      filterable: false,
      hidden: true,
    },

    {
      field: "mainDescription",
      title: "Main Description",
      width: 150,
    },
  ];

  const childColumn = [
    {
      field: "rentalHighlightsID",
      hidden: true,
    },
    { field: "sortOrder", hidden: true },
    {
      field: "title",
      title: "Title",
    },
    {
      field: "description",
      title: "Description",
      template: function (e) {
        const maxLength = 50;
        return e.description?.length > maxLength
          ? `${e.description.substring(0, maxLength)}...`
          : e.description;
      },
    },
  ];

  const onSubmit = async (e) => {
    e.preventDefault();

    const err = ValidateForm(e);
    if (err) {
      setError(err);
    } else {
      const formData = new FormData();

      formData.append("rentalHighlightsID", MainDescription.rentalHighlightsID);
      formData.append("mainDescription", MainDescription.MainDescription);
      formData.append("savedBy", sessionUser());

      try {
        await corepost(
          "RentalHighlights/InsertUpdateMainDescription",
          formData,
          true,
          true,
          false,
          false
        );
        setrefreshflag(refreshflag + 1);
        clearForm();
        $("#VendorServices-cancel").click();
      } catch (error) {
        console.error("Error while submitting the form:", error);
      }
    }
  };

  const onRentalHighlightsSubmit = async (e) => {
    e.preventDefault();
    const err = ValidateForm(e);
    if (err) {
      setError(err);
    } else {
      setLoading(true);
      const formData = new FormData();
      formData.append(
        "rentalHighlightsID",
        RentalHighlights.rentalHighlightsID
      );
      formData.append("title", RentalHighlights.Title);
      formData.append("description", RentalHighlights.Description);
      formData.append("SavedBy", sessionUser());
      try {
        await corepost(
          "RentalHighlights/InsertUpdateRentalHighlights",
          formData,
          true,
          true,
          false,
          false
        );
        setLoading(false);
        const modalElement = document.getElementById("add_Guideline");
        const modalInstance = bootstrap.Modal.getInstance(modalElement);
        if (modalInstance) {
          modalInstance.hide();
        }
        refreshChildGrd();
        clearRentalHighlights();
      } catch (error) {
        console.error("Error while submitting the form:", error);
      }
    }
  };

  const onParentEditClick = async (e) => {
    let temp = MainDescription;
    MainDescription.rentalHighlightsID = e.rentalHighlightsID;
    MainDescription.MainDescription = e.mainDescription;

    setMainDescription(temp);
    setEditVisible(true);

    const modal = new bootstrap.Modal(
      document.getElementById("add_VendorServices")
    );
    modal.show();
  };

  const onRentalHighlightsAdd = async (e) => {
    const modal = new bootstrap.Modal(document.getElementById("add_Guideline"));
    modal.show();
  };

  const onhighlightsEditClick = async (e) => {
    setRentalHighlightseditVisible(true);
    setRentalHighlights((prev) => ({
      ...prev,
      rentalHighlightsID: e.child.rentalHighlightsID,
      Title: e.child.title,
      Description: e.child.description,
    }));
    const modal = new bootstrap.Modal(document.getElementById("add_Guideline"));
    modal.show();
  };

  const handlePatentDeleteClick = async (e) => {
    const onDelete = () => {
      corefetch(
        `PreferedVendors/DeletePreferedVendors?preferedVendorId=${
          e.vendorServicesID
        }&deletedBy=${sessionUser()}`,
        true,
        false,
        true
      ).then(() => {
        setrefreshflag((prev) => prev + 1);
      });
    };
    confirmDelete(onDelete);
  };
  const handleChildDeleteClick = async (e) => {
    const onDelete = () => {
      corefetch(
        `RentalHighlights/DeleteRentalHighlights?rentalhighlightsId=${
          e.rentalHighlightsID
        }&deletedBy=${sessionUser()}`,
        true,
        false,
        true
      ).then(() => {
        refreshChildGrd();
      });
    };
    confirmDelete(onDelete);
  };
  const onValidation = (name, val) => {
    setError((prvErr) => {
      return {
        ...prvErr,
        [name]:
          !val || (val && val.trim() == "") || (val && val.trim().length == 0),
      };
    });
  };
  const onRowReorderChange = async (List) => {
    try {
      let rentalHighlightsID = $(List.newRow).find("td").eq(0).text();
      let oldSortId = $(List.newRow).find("td").eq(1).text();
      let newSortId = $(List.oldRow).find("td").eq(1).text();
      await corefetch(
        `RentalHighlights/SortRentalHighlights?TypeId=${rentalHighlightsID}&newSortId=${newSortId}&oldSortId=${oldSortId}`
      );
      refreshChildGrd();
    } catch (error) {
      console.error("Error during row reorder:", error);
    }
  };

  const clearForm = () => {
    setMainDescription({
      rentalHighlightsID: 0,
      MainDescription: "",
    });
    setError({});
    setEditVisible(false);

    const form = document.getElementById("form-culture-config");
    if (form) {
      form.reset();
    }
  };

  const clearRentalHighlights = () => {
    $("#Guideline-cancel").click();

    setRentalHighlights({
      rentalHighlightsID: 0,
      Title: "",
      Description: "",
    });
    $("#GFile").val("");
    setError({});
    setRentalHighlightseditVisible(false);
    const form = document.getElementById("Guideline-form");
    if (form) {
      form.reset();
    }
  };

  const refreshChildGrd = () => {
    $(`#reload-BannerTreetable`)
      .next()
      .find(".k-master-row")
      .each(function (index) {
        if ($(this).find("td:first").find("a:first").hasClass("k-i-collapse")) {
          $(this).next().find(".btn-refresh:first").click();
        }
      });
  };

  const fetchData = async () => {
    try {
      const list = await corefetch("PreferedVendors/GetVendorsDetails");
      setVendorGridList(list);
    } catch (error) {
      console.error("Error fetching list:", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const list = await corefetch("RentalHighlights/GetMainDescription");
        setMainDescriptionData(list);
        if (list && list.length > 0) {
          setHideAdd(true);
        } else {
          setHideAdd(false);
        }
      } catch (error) {
        console.error("Error fetching list:", error);
        setHideAdd(false);
      }
    };

    fetchData();
  }, [refreshflag]);
  return (
    <>
      <div className="page-header">
        <div className="row">
          <div className="col-sm-12">
            <h3 className="page-title">Rental Highlights</h3>
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <li>Configuration</li>
              </li>
              <li className="breadcrumb-item active">Rental Highlights</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="card bg-white">
        <div className="card-body">
          <div className="col-auto ms-auto">
            <div className="row">
              <div className="col-sm-6"></div>
              <div className="col-auto float-end ms-auto">
                <div className="d-flex justify-content-end mb-2">
                  {!HideAdd && (
                    <Button
                      name={"Add"}
                      dataBsToggle={"modal"}
                      dataBsTarget={"#add_VendorServices"}
                      dataBsDismiss={"modal"}
                    />
                  )}
                </div>
              </div>
            </div>

            <div>
              <KendoTreeTable
                name={"BannerTreetable"}
                parentTableUrl={
                  CorebaseURL + "RentalHighlights/GetMainDescription"
                }
                parentTableColumns={Parentscolumns}
                childTableUrl={
                  CorebaseURL + "RentalHighlights/GetRentalHighlightsDetails"
                }
                childTableColumns={childColumn}
                showParentOptions={true}
                showParentAdd={true}
                showParentEdit={true}
                showParentDelete={false}
                onParentAddClick={onParentEditClick}
                onParentEditClick={onRentalHighlightsAdd}
                // onParentDeleteClick={handlePatentDeleteClick}
                showChildOptions={true}
                showChildDelete={true}
                onChildEditClick={onhighlightsEditClick}
                onChildDeleteClick={handleChildDeleteClick}
                enableRowReorderable={true}
                onRowReorder={onRowReorderChange}
                refreshWhen={refreshflag}
                parentpaggable={false}
                noteLabel="Note:"
                noteContent="This module supports drag-and-drop functionality, you can easily
                        rearrange or move data as needed."
              />
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Add VendorServices Modal --> */}
      <div
        className="modal custom-modal fade"
        id="add_VendorServices"
        role="dialog"
        ref={modalRef}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div
          className="modal-dialog modal-dialog-centered VendorServices"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{editVisible ? "Edit" : "Add"}</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  clearForm();
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="form-culture-config" onSubmit={onSubmit}>
                <input
                  type="hidden"
                  name="ID"
                  value={MainDescription.rentalHighlightsID || 0}
                />

                {/* Single Column Layout */}
                <div className="row">
                  <div className="col-12 mb-3">
                    <div className="input-block">
                      <label className="form-label">
                        Main Description <span className="text-danger">*</span>
                        <InfoIcon content="Please provide a Main Description with a maximum length of 400 characters." />
                      </label>
                      <textarea
                        type="text"
                        maxLength={400}
                        className="form-control field"
                        name="MainDescription"
                        value={MainDescription.MainDescription || ""}
                        placeholder="Main Description"
                        data-required="true"
                        onChange={(e) => {
                          setMainDescription((prev) => ({
                            ...prev,
                            MainDescription: e.target.value,
                          }));
                          onValidation("MainDescription", e.target.value);
                        }}
                      />
                      {error.MainDescription && (
                        <ErrorMsg text="Main Description is required" />
                      )}
                    </div>
                  </div>
                </div>

                <div className="text-end">
                  <Button
                    name={"Cancel"}
                    isCancelButton={true}
                    id="VendorServices-cancel"
                    dataBsDismiss={"modal"}
                    onClick={() => {
                      clearForm();
                    }}
                  />
                  {/* <Button name={"Save"} /> */}
                  <Button name={editVisible ? "Update" : "Save"} />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- /Add VendorServices Modal --> */}

      {/* <!-- Add Guideline Modal --> */}
      <div
        className="modal custom-modal fade"
        id="add_Guideline"
        role="dialog"
        ref={GuidelinemodalRef}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div
          className="modal-dialog modal-dialog-centered rentalHighlights"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                {RentalHighlightseditVisible
                  ? "Edit Highlights"
                  : "Add Highlights"}
              </h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  clearRentalHighlights();
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="Guideline-subForm" onSubmit={onRentalHighlightsSubmit}>
                <input
                  type="hidden"
                  name="bannerID"
                  value={RentalHighlights.rentalHighlightsID}
                />

                <div className="row">
                  <div className="col-md-12 mb-3">
                    <label className="form-label">
                      Title <span className="text-danger">*</span>
                      <InfoIcon content="Please provide a Title with a maximum length of 30 characters." />
                    </label>
                    <input
                      type="text"
                      maxLength={30}
                      className="form-control field"
                      name="Title"
                      value={RentalHighlights.Title}
                      placeholder="Title"
                      data-required="true"
                      onChange={(e) => {
                        onValidation("Title", e.target.value);
                        setRentalHighlights((prev) => ({
                          ...prev,
                          Title: e.target.value,
                        }));
                      }}
                    />
                    {error.Title && <ErrorMsg text="Title is required" />}
                  </div>
                  <div className="col-md-12 mb-3">
                    <label className="form-label">
                      Description <span className="text-danger">*</span>
                      <InfoIcon content="Please provide a Description with a maximum length of 300 characters." />
                    </label>
                    <textarea
                      type="text"
                      maxLength={300}
                      className="form-control field"
                      name="Description"
                      value={RentalHighlights.Description}
                      placeholder="Description"
                      data-required="true"
                      onChange={(e) => {
                        onValidation("Description", e.target.value);
                        setRentalHighlights((prev) => ({
                          ...prev,
                          Description: e.target.value,
                        }));
                      }}
                    />
                    {error.Description && (
                      <ErrorMsg text="Description is required" />
                    )}
                  </div>
                </div>

                {Loading ? (
                  <KendoLoader className="d-flex justify-content-end align-items-center" />
                ) : (
                  <div className="text-end">
                    <Button
                      name={"Cancel"}
                      isCancelButton={true}
                      id="Guideline-cancel"
                      dataBsDismiss={"modal"}
                      onClick={() => {
                        clearRentalHighlights();
                      }}
                    />
                    <Button
                      name={RentalHighlightseditVisible ? "Update" : "Save"}
                    />
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
